import { render, staticRenderFns } from "./ChecklistFloatFieldModule.vue?vue&type=template&id=16ed2a7d&scoped=true"
import script from "./ChecklistFloatFieldModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChecklistFloatFieldModule.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ed2a7d",
  null
  
)

export default component.exports